import { useCallback } from 'react';
import { monitoring } from '../services/monitoring.service';

export function useETLMonitoring(entity?: string) {
  const captureError = useCallback((error: Error, context?: any) => {
    monitoring.captureError(error, {
      entity: entity || 'unknown',
      ...context,
    });
  }, [entity]);

  const captureValidationError = useCallback((
    row: number,
    field: string,
    value: any,
    message: string
  ) => {
    monitoring.captureValidationError(
      entity || 'unknown',
      row,
      field,
      value,
      message
    );
  }, [entity]);

  const logEvent = useCallback((event: string, data?: any) => {
    monitoring.logBusinessEvent(event, {
      entity: entity || 'unknown',
      ...data,
    });
  }, [entity]);

  return {
    captureError,
    captureValidationError,
    logEvent,
  };
}